import { generateConsecutiveDateLabels } from '../helpers';

const dateLabels = generateConsecutiveDateLabels();

const values = [
  '21',
  '12',
  '17',
  '14',
  '8',
  '15',
  '8',
  '10',
  '16',
  '13',
  '11',
  '17',
  '18',
  '14',
  '27',
  '23',
  '26',
  '12',
  '27',
  '14',
  '9',
  '30',
  '25',
  '31',
  '12',
  '9',
  '8',
  '17',
  '11',
  '3',
];

export const tasksCreatedByAirDummyData = {
  data: dateLabels.map((name, idx) => {
    return {
      name,
      aggValue: values[idx],
      values: [],
    };
  }),
  aggregates: {
    staffAnswered: '0',
    staffUnanswered: '0',
    followupTasksScheduling: '0',
    followupTasksOthers: '0',
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: '0',
    totalAiThreads: '0',
  },
};
